import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURLMapping = {
  drmBidTableData: URLS.DRM_MARK_FOR_EXPIRE,
};

export const drmExpireTableData = async ([userCode, submitDetails, tableName, controller]) => {
  const response = await axios.post(
    `${tableURLMapping[tableName]}`,
    { userCode, submitDetails },
    { signal: controller.signal }
  );

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
